module.exports = __webpack_public_path__ + "static/img/new-15.8e4fdf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-15.png
// module id = 5KLC
// module chunks = 0